import { render, staticRenderFns } from "./editShipment.vue?vue&type=template&id=0e2b6df7&"
import script from "./editShipment.vue?vue&type=script&lang=js&"
export * from "./editShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports